import { Box, SystemStyleObject } from "@chakra-ui/react";
import { OrSperator } from "./OrSperator";
import SocialButtonsGroup from "./SocialButtonsGroup";
import { useLoginApi } from "../apis";
import { ISaveDataEvent } from "../types";

type IProps = {
  sx?: SystemStyleObject;
  type?: "login" | "signup";
};

const InfoGropup = (props: IProps) => {
  const { handleSocialSignInSignUp } = useLoginApi();

  const event: ISaveDataEvent = window.location.pathname.includes("signup")
    ? "SIGNUP"
    : "LOGIN";

  // const handleAppleLogin = () => handleSocialSignInSignUp("apple.com", event);
  // const handleFacebookSignInSignUp = () =>
  //   handleSocialSignInSignUp("facebook.com", event);
  const handleGoogleSignInSignUp = () =>
    handleSocialSignInSignUp("google.com", event);

  return (
    <Box display={{ base: "flex" }} sx={props.sx}>
      <OrSperator sx={{ my: "1rem", fontWeight: "bold" }} />
      <SocialButtonsGroup
        type={props.type}
        // onAppleClick={handleAppleLogin}
        // onFacebookClick={handleFacebookSignInSignUp}
        onGoogleClick={handleGoogleSignInSignUp}
      />
    </Box>
  );
};

export default InfoGropup;
